module.exports = __webpack_public_path__ + "static/img/14.a876e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/14.png
// module id = Kulq
// module chunks = 0